{
  "addIndividualEffort": "Legg til enkeltvis egeninnsats",
  "addIndividually": "Legg til enkeltvis",
  "addSelfEffort": "Legg til egeninnsats",
  "approveSelfEffort": "Godkjenn egeninnsats",
  "byTotal": "Av totalt {{amount}} kr",
  "cannotBeAfterDate": "Kan ikke være etter {{ value }}",
  "cannotBeBeforeDate": "Kan ikke være før {{ value }}",
  "changelog.import.dateHeaderChanged": "Overskriften for Dato-kolonnen er endret for mindre enn 30 dager siden. Endre datokolonneoverskriften slik at den samsvarer med malen, eller bruk den nye malen.",
  "changelog.import.uspecified": "Det har skjedd en endring på malen, som ikke er spesifisert, for under 30 dager siden. Vennligst last ned malen på nytt for å kunne importere uten feil.",
  "changeMultipleRows": "Her kan du endre tid og timesats for flere rader egeninnsats samtidig.",
  "contactNotSelected": "Kontakter må ha blitt valgt",
  "contactSelfEffortIntro": "Her ligger all egeninnsats registrert hos kontakten",
  "contactsNotInResourceBase": "Disse kontaktene er ikke med i ressursbasen. Ønsker du å legge dem inn og godkjenne deres egeninnsats?",
  "contactsUnsubscribed": "Disse kontaktene er utmeldt frå ressursbasen. De får ikke egeninnsats godkjent.",
  "couldNotChangeInkind": "Kunne ikke endre egeninnsats. Prøv igjen.",
  "couldNotCreateInKind": "Kunne ikke opprette egeninnsats. Prøv igjen.",
  "couldNotDelete": "Kunne ikke slette egeninnsats. Prøv igjen.",
  "deleteAreYouSure": "Er du helt sikker på at du vil slette disse egeninnsatsradene? Denne handlingen kan ikke angres.",
  "deleteSelfEffort": "Slett egeninnsats",
  "downloadTemplate": "Last ned mal",
  "downloadTemplateTip": "For å gjøre det enklere å importere inn data, anbefaler vi at dere laster ned vår Excel-mal:",
  "editSelfEffort": "Rediger egeninnsats",
  "errorCode.ValidSource": "Kilde må være import, lenke eller manuell",
  "errorCode.ValidStatus": "Status må være Tellende, Ikke-tellende eller til godkjenning",
  "estimatedHoursByHourlyRate": "* estimert {{hours}} timer gjenstår med {{hourlyRate}},- som timesats",
  "getFromWorkGroup": "Hent fra arbeidsgruppe",
  "hourlyRateKept": "Opprinnelig timesats blir beholdt",
  "hoursIsNaN": "Antall timer og minutter er ikke gyldig",
  "hoursNotLessThanZero": "Timer kan ikke være mindre enn null",
  "hoursRegistered": "timer registrert",
  "ImportedSelfEffort": "Importert egeninnsats.",
  "importInkind": "Importer egeninnsats",
  "inkindContactDeleted": "Kan ikke gå til siden, denne kontakten er slettet",
  "inkindDateOptional": "Dato for egeninnsats (valgfri)",
  "inkindMemberDeleted": "Kan ikke gå til siden, denne bedriften er slettet",
  "inkindOverview": "Egeninnsatsoversikt",
  "inkindReadyToregister_many": "{{ rows }} rader egeninnsats klare for registrering.",
  "inkindReadyToregister_one": "Én rad egeninnsats klar for registrering.",
  "inkindRegistered_many": "{{ rows }} rader egeninnsats registrert.",
  "inkindRegistered_one": "Én rad egeninnsats registrert.",
  "inkindUploading": "Egeninnsatsopplasting",
  "keepContactHourRate": "Behold kontaktens timesats",
  "keepOriginalHourRate": "Behold opprinnelig timesats",
  "keepOriginalStatus": "Behold opprinnelig status",
  "markedRowsAlreadyApproved": "Valgte rader er allerede godkjent",
  "memberHours": "Registrerte timer hos medlemmer",
  "memberInKind": "Egeninnsats hos medlemmer",
  "minutesCannoteBeLessThanZero": "Minutter kan ikke være mindre enn 0",
  "mustSelectEvent": "Du må velge et event før du kan laste opp egeninnsats.",
  "needsApproval": "Må godkjennes",
  "newContactsAdded_many": "{{ newContacts }} kontakter finnes ikke i ressursbasen og blir opprettet.",
  "newContactsAdded_one": "Én kontakt finnes ikke i ressursbasen og blir opprettet.",
  "newHourlyRate": "Ny timesats blir {{ hourlyRate }}",
  "newMembersAdded_many": "{{ newMembers }} medlemmer finnes ikke i ressursbasen og blir opprettet.",
  "newMembersAdded_one": "Ett medlem finnes ikke i ressursbasen og blir opprettet.",
  "newStatus": "Ny status for egeninnsats blir {{ status }}",
  "newTime": "Ny tid blir {{ hours }}t {{ minutes }}m.",
  "noContactsSelected": "Ingen kontakter valgt.",
  "noRowsToUpload": "Ingen egeninnsatsrader å laste opp.",
  "noTimechange": "Opprinnelig tid blir beholdt.",
  "numberOfApprovedRows_many": "Det er {{ approvedNumber }} som er godkjente blant egeninnsatsradene",
  "numberOfApprovedRows_one": "Det er en som er godkjent blant egeninnsatsradene",
  "numberOfContacts": "Antall kontakter",
  "numberOfHours": "Antall timer",
  "numberOfMinutes": "Antall minutter",
  "participantCompanies": "Antall prosjektdeltagere (bedrifter):",
  "regiseredEffortHours": "Registrerte timer",
  "registeringError": "Feil ved forsøk på egeninnsatsregistrering. Trykk vis for detaljer.",
  "registerMultiple": "Registrer flere",
  "registerSelfEffort": "Registrer egeninnsats",
  "registerSingel": "Registrer en",
  "removeAll": "Fjern alle",
  "removeSelectedContact": "Fjern valgt kontakt",
  "selectEventHelpText": "Prosjekt må velges før event kan velges. Dersom det ikke er opprettet eventer i prosjektet kan du ikke velge event her.",
  "selfEffort": "Egeninnsats",
  "selfEffortStatus": "Egeninnsatsstatus",
  "sendRegistration": "Send inn registrering",
  "statusKept": "Opprinnelig egeninnsatsstatus blir beholdt.",
  "submittingInKind": "Sender egeninnsats...",
  "totalEffortBasedOnHours": "Total egeninnsats for dette prosjekter basert på registrerte timer:",
  "totalFromContacts": "Total godkjent egeninnsats samlet inn fra kontakter i dette prosjektet: ",
  "totalTimeLessThanZeroHours": "Total tid kan ikke være mindre enn 0 timer"
}
